import { api } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const LeaderAPIs = {

    GetLeaderTours: async function (userID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/leadertourlist/' + userID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetLeaderTourPassengerCount: async function (bookingID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/registeredPassengerCount/' + bookingID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetReceiptsStatement: async function (bookingID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/renderbookingstatement/' + bookingID + '/STC - Receipts',
            method: 'GET',
            data: [],
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    // Returns a list of leader passengers associated with a tour
    GetLeaderPassengersForTour: async function (userID, bookingID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/leadergetpassengers/' + userID + '/' + bookingID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    GetPayments: async function (bookingID, cancel = false){
        const response = await api.request({
            url: "/school-tour-company/rest/portal/renderbookingstatement/" + bookingID + "/STC - Receipts",
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: 'blob',
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostDownloadBookingStatement: async function (bookingID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/bookingstatement',
            method: 'POST',
            data: bookingID,
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: 'blob',
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostDownloadReceiptsStatement: async function (bookingID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/receiptsstatement',
            method: 'POST',
            data: bookingID,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    
}
const cancelAPIObject = defineCancelApiObject(LeaderAPIs)